import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.5 7.5H14.5M14.5 7.5L10.5 4M14.5 7.5L10.5 11M9 13.5H2.4375C1.92 13.5 1.5 13.116 1.5 12.6429V2.35714C1.5 1.884 1.92 1.5 2.4375 1.5H9",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconLogout;
